import { useRef } from 'react';

import { getDeviceConfiguration } from './getDeviceConfiguration';

export function useDeviceConfigurationCache() {
  const deviceConfiguation = useRef(getDeviceConfiguration());

  // TODO: throw error only in development
  // if (!deviceConfiguation.current) {
  //   throw new Error('Device Configuration is empty. Did you forget to initRhino?');
  // }

  return { configuration: deviceConfiguation.current };
}
